// This file is the main entry point for loading the month calendar as a spud.

declare function supportsES6(): boolean;

import { render } from "solid-js/web";
import MonthCalendar from "./MonthCalendar";

if (supportsES6()) render(() => <MonthCalendar />, document.getElementById("root") as HTMLElement);
